import { Shape } from './index.js';

export class Text extends Shape {
	constructor({
		x = 0,
		y = 0,
		text = '',
		font = '16px Arial',
		color = 'black',
		textAlign = 'left',
		textBaseline = 'top',
		rotation = 0,
		shadow = {},
		fontWeight = 'normal',
		textTransform = 'none',
		textDecoration = 'none'
	}) {
		super({ x, y, fillRule: 'color', fill: color, rotation, shadow });
		this.text = text;
		this.font = font;
		this.textAlign = textAlign;
		this.textBaseline = textBaseline;
		this.fontWeight = fontWeight;
		this.textTransform = textTransform;
		this.textDecoration = textDecoration;
	}

	applyStyles(context) {
		super.applyStyles(context);
		context.font = `${this.fontWeight} ${this.font}`;  // Combine weight and font family/size
		context.textAlign = this.textAlign;
		context.textBaseline = this.textBaseline;
		context.fillStyle = this.fill.color;

		// Handle text transform (e.g., uppercase, lowercase, etc.)
		if (this.textTransform === 'uppercase') {
			this.text = this.text.toUpperCase();
		} else if (this.textTransform === 'lowercase') {
			this.text = this.text.toLowerCase();
		} else if (this.textTransform === 'capitalize') {
			this.text = this.text.replace(/\b\w/g, char => char.toUpperCase());
		}

		// Handle text decoration (underline, line-through)
		if (this.textDecoration === 'underline') {
			context.setLineDash([5, 5]); // Optional: add a dashed line for underline effect
			context.beginPath();
			context.moveTo(0, 5);  // Adjust this to your text position
			context.lineTo(context.measureText(this.text).width, 5); // Adjust based on text width
			context.stroke();
			context.setLineDash([]); // Reset dashed line
		} else if (this.textDecoration === 'line-through') {
			context.setLineDash([5, 5]); // Optional: add a dashed line for line-through effect
			context.beginPath();
			context.moveTo(0, -5);  // Adjust this to your text position
			context.lineTo(context.measureText(this.text).width, -5); // Adjust based on text width
			context.stroke();
			context.setLineDash([]); // Reset dashed line
		}
	}

	draw(context) {
		context.save();
		context.rotate(this.rotation * Math.PI / 180);
		this.applyStyles(context);

		const x = typeof this.position.x == 'function' ? this.position.x(context) : this.position.x;
		const y = typeof this.position.y == 'function' ? this.position.y(context) : this.position.y;

		context.translate(x, y);

		// Draw the text
		context.fillText(this.text, 0, 0);
		this.beforeRestore(context)
		context.restore();
	}
}
